import { render, staticRenderFns } from "./ProjectInvoices.vue?vue&type=template&id=564ba468&"
import script from "./ProjectInvoices.vue?vue&type=script&lang=js&"
export * from "./ProjectInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports